import { IGetAllEntregaObrasClienteUseCase } from "../../../presentation/useCases/read/get_all_entrega_obras_cliente_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { EntregaObraClienteLista } from "../../models/entrega_obra_cliente_lista";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAllEntregaObrasClienteUseCase
 */

export class GetAllEntregaObrasClienteUseCase
  extends BasePaginatedUseCase<EntregaObraClienteLista>
  implements IGetAllEntregaObrasClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }

  async execute(
    idEntregaObra: number,
    idsClientes?: number[],
    idsChecklist?: number[],
    tipoVistoria?: number,
    entregue?: number,
    unidade?: string,
    localVistoria?: string,
    dataDe?: Date,
    dataAte?: Date,

    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const result = await this.repository.getAllEntregaObrasClienteLista(
      idEntregaObra,
      idsClientes,
      idsChecklist,
      tipoVistoria,
      entregue,
      unidade,
      localVistoria,
      dataDe,
      dataAte,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalPages = result.totalPages;
  }
}
